import { BellOutlined } from "@ant-design/icons"
import { type EventContentArg } from "@fullcalendar/core"
import { Flex, Typography } from "antd"
import React from "react"

const { Text } = Typography

interface CalendarEventCellReminderProps {
  eventInfo: EventContentArg
}

export function CalendarEventCellReminder({
  eventInfo
}: CalendarEventCellReminderProps) {
  const event = eventInfo?.event
  const title = event?.title || ""
  const isCompleted = event?.extendedProps?.is_completed

  return (
    <div
      className={`size-full pt-0.5 overflow-hidden ${isCompleted ? "line-through opacity-50" : ""}`}
    >
      <Flex vertical gap={"small"}>
        <Flex align={"start"} gap={3}>
          <BellOutlined
            style={{ fontSize: "16px", color: `${eventInfo?.textColor}` }}
          />
          <Text strong ellipsis className="text-xs text-inherit">
            {title}
          </Text>
        </Flex>
        <Text
          className={"break-all text-inherit"}
          ellipsis={{
            tooltip: event?.extendedProps?.description
          }}
        >
          {event?.extendedProps?.description}
        </Text>
      </Flex>
    </div>
  )
}
